import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_PRIORITIES } from "../../../utils/constants";
import priorityService from "../../../services/ticketService/priorityService";
import { PriorityInterface } from "../../../models/TicketModule/Priority";

const usePriorities = (page: number, pageSize: number) =>
  useQuery<PriorityInterface[], Error>({
    queryKey: [
      CACHE_KEY_PRIORITIES,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => priorityService.GetAll(page, pageSize),
  });

export default usePriorities;
